import { createStaticDataSource } from './staticDataSource';
var dataSources = {};
var emptyDataSource = createStaticDataSource({});
export function setDataSource(name, dataSource) {
    dataSources[name] = dataSource;
}
/**
 * Set the dataSource under a name if not already set
 * @param name name of the dataSource
 * @param dataSource the dataSource to be set
 * @returns true if the dataSource is set successfully
 */
export function trySetDataSource(name, dataSource) {
    if (!dataSources[name]) {
        dataSources[name] = dataSource;
        return true;
    }
    return false;
}
export function getDataSource(name) {
    if (!dataSources.hasOwnProperty(name)) {
        throw new Error("dataSource '" + name + "' was not set yet");
    }
    return dataSources[name];
}
export function tryGetDataSource(name, fallbackDataSource) {
    if (!dataSources.hasOwnProperty(name)) {
        if (fallbackDataSource) {
            return fallbackDataSource;
        }
        else {
            return emptyDataSource;
        }
    }
    return dataSources[name];
}
/**
 * Try to get RICE data source. This approach is technically applicable to all HVCs, but
 * due to it being a workaround, we are scoping it to RICE for now
 * @param name data source name,
 * @param dataHvcId
 * @param fallbackDataSource
 * @returns
 */
export function tryGetRiceDataSource(dataHvcId, fallbackDataSource) {
    var dataSourceName = "centro.hvc.riceData";
    if (dataHvcId) {
        dataSourceName = 'centro.hvc.riceData' + "_" + dataHvcId;
    }
    return tryGetDataSource(dataSourceName, fallbackDataSource);
}
